module.exports = __webpack_public_path__ + "img/canteen.d1353623.png";